import type { ComponentDefinition } from '@/types/reports';
import { sanitizeTiktokTrendsProps } from '@/pages/reports/components/ui/TiktokTrends/utils/hasContent';

export function componentPropsToSave(
  componentDef: ComponentDefinition | null,
  componentProps: Record<string, any>
): Record<string, any> {
  if (!componentDef) return { ...componentProps };
  if (componentDef.type === 'tiktok-trends') {
    return sanitizeTiktokTrendsProps(componentProps);
  }
  if (componentDef.type === 'news-card') {
    const {
      tooltipTitleWord: _tooltipTitleWord,
      tooltipTitleWordBackgroundColor: _tooltipTitleWordBackgroundColor,
      tooltipTitleWordTextColor: _tooltipTitleWordTextColor,
      tooltipItems: _tooltipItems,
      tooltipBackgroundColor: _tooltipBackgroundColor,
      tooltipTextColor: _tooltipTextColor,
      subtitle: _subtitle,
      tooltips: _tooltips,
      ...rest
    } = componentProps;
    const subsections = (componentProps.subsections ?? []).map((section: any) => ({
      ...section,
      tooltips: (section.tooltips ?? []).map(({ items: _items, ...t }: any) => t),
    }));
    return { ...rest, subsections };
  }
  return { ...componentProps };
}
